import {RootStore} from "./rootStore";
import {action, observable, makeObservable, runInAction} from "mobx";

export default class FilterPanelStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;

    makeObservable(this, {
      filterPanelShown: observable,
      toggleFilterPanelState: action
    });
  }

  filterPanelShown = false;

  toggleFilterPanelState = () => {
    this.filterPanelShown = !this.filterPanelShown;
  }
}